import { setUpdateData } from 'store/actions/canvasActions';

export const getColor = (props, key) => {
  const themeColors = props.theme.colors[props.$selectedTheme];
  return themeColors[key];
};

export const exists = value => {
  return value !== undefined;
};

export const updateCanvas = (updateArgs, payload) => {
  const { dispatch, type, method } = updateArgs;

  const inboundData = {
    type,
    method,
    payload,
  };

  dispatch(setUpdateData(inboundData));
};

export const getBase64StringFromDataURL = dataURL => {
  if (typeof dataURL !== 'string') return '';
  return dataURL.replace('data:', '').replace(/^.+,/, '');
};

export const hexValid = val => {
  const isValid = val?.startsWith?.('#') && (
    val?.length === 4
    || val?.length === 7
    || val?.length === 9
  );

  if (isValid) return val;
};